import React, { useState } from "react";
import { Formik } from "formik";
import SelectDropdown from "../../../../../components/common-components/selectDropdown";
import { ABHA_HEALTH_RECORD_FIELDS, ENCOUNTER_CLASSIFICATION_OPTIONS } from "../Constants";
import Input from "../../../../../components/common-components/input/Input";
import Button from "../../../../../components/common-components/button/Button";
import { BUTTON_VARIANTS } from "../../../../../components/common-components/button/Constants";
import ModalComponent from "../../../../../components/common-components/modal/ModalComponent";
import { ENCOUNTER_STATUS } from "../Constants";
import { v4 as uuidv4 } from 'uuid';
import ItemManager from "../ItemManager";
import EncounterDiagnosis from "./EncounterDiagnosis";
import HealthRecordHelper from "../utils/utils";

const Encounter = ({ open, close, onConfirm }) => {
    const [diagnosisList, setDiagnosisList] = useState([]);
    const [isDiagnosisPopupOpen, setIsDiagnosisPopupOpen] = useState(false);
    const validate = (values) => {
        const errors = {};
        if (!values.encounterStatus || values.encounterStatus.value === "Select Status") {
            errors.encounterStatus = "Please select a Encounter status.";
        }
        if(!values[ABHA_HEALTH_RECORD_FIELDS.ENCOUNTER_CLASSIFICATION]){
            errors[ABHA_HEALTH_RECORD_FIELDS.ENCOUNTER_CLASSIFICATION] = "Please provide a classification";
        }
        const startTime = values[ABHA_HEALTH_RECORD_FIELDS.ENCOUNTER_PERIOD_START];
        const endTime = values[ABHA_HEALTH_RECORD_FIELDS.ENCOUNTER_PERIOD_END];

        if (startTime && endTime && new Date(endTime) < new Date(startTime)) {
            errors[ABHA_HEALTH_RECORD_FIELDS.ENCOUNTER_PERIOD_END] = "End Time cannot be earlier than Start Time.";
        }
        return errors;
    };

    return(
        <>
            <Formik
                initialValues={{
                    encounterStatus: { label: "Select Status", value: "Select Status" },
                    [ABHA_HEALTH_RECORD_FIELDS.ENCOUNTER_CLASSIFICATION]: {label: "", value: ""},
                }}
                validate={validate}
                onSubmit={(values) => {
                    const encounterData= {
                        resourceType: "Encounter",
                        id: uuidv4(),
                        status: values.encounterStatus.value,
                        class: {
                            code: values[ABHA_HEALTH_RECORD_FIELDS.ENCOUNTER_CLASSIFICATION].value,
                            display: values[ABHA_HEALTH_RECORD_FIELDS.ENCOUNTER_CLASSIFICATION].label.toLowerCase(),
                        },
                    }
                    const formattedData = HealthRecordHelper.removeEmptyFields(encounterData)
                    onConfirm((prev) => [...prev, {type: `Encounter Report ${prev.length + 1}`, data: formattedData}])
                    close()
                }}
            >
              {({ values, errors, setFieldValue, handleSubmit }) => (
                 <ModalComponent
                    open={open}
                    title={"Encounter Context"}
                    footerButton={
                        <Button
                            variant={BUTTON_VARIANTS.CONTAINED}
                            onClickCb={() => handleSubmit()}
                        >
                            Submit
                        </Button>
                    }
                    close={() => close()}
                    customClasses="w-[90%] max-w-5xl"
                    hideOverflow={true}
                >
                    <div className="grid grid-cols-2 gap-4">
                        <SelectDropdown
                            label="Encounter Status"
                            name="encounterStatus"
                            customClasses="w-full"
                            isRequired={true}
                            value={values.encounterStatus}
                            options={[{ label: "Select Status", value: "Select Status" }, ...ENCOUNTER_STATUS]}
                            onChangeCb={(selectedOption) =>
                                setFieldValue("encounterStatus", selectedOption)
                            }
                        />
                        <SelectDropdown
                            label="Classification"
                            name="encounterClassification"
                            customClasses="w-full"
                            placeholder="Select"
                            isRequired={true}
                            value={values[ABHA_HEALTH_RECORD_FIELDS.ENCOUNTER_CLASSIFICATION]}
                            options={ENCOUNTER_CLASSIFICATION_OPTIONS}
                            onChangeCb={(selectedOption) =>
                                setFieldValue(
                                    ABHA_HEALTH_RECORD_FIELDS.ENCOUNTER_CLASSIFICATION,
                                    selectedOption
                                )
                            }
                        />       
                    </div>
                </ModalComponent>
            )}
        </Formik>
    </>
    )
}
export default Encounter;